import React, { useEffect, useState } from "react";
import { generateXZReportData, archiveZReport } from "../../data/reports";
import { printHtml } from "../../data/print";
import { useAuth } from "../../context/AuthContext";

const ZClosureModal = ({ show, onClose, onConfirm }) => {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [actualCash, setActualCash] = useState("");
  const [step, setStep] = useState(1); // 1: Preview, 2: Declare Cash & Confirm
  const [isArchiving, setIsArchiving] = useState(false);

  useEffect(() => {
    if (show) {
      let isMounted = true;
      setLoading(true);
      setStep(1);
      setActualCash("");
      generateXZReportData().then(report => {
        if (isMounted) {
          setData(report);
          setLoading(false);
        }
      });
      return () => { isMounted = false; };
    }
  }, [show]);

  if (!show) return null;

  const handlePrintZ = (zData, finalCash, diff) => {
    const html = `
      <div style="font-family: monospace; width: 300px; padding: 10px; font-size: 14px;">
        <h2 style="text-align: center; margin: 0 0 10px 0;">CLÔTURE (Z)</h2>
        <div style="text-align: center; margin-bottom: 20px;">
          ${new Date().toLocaleString("fr-FR")}
        </div>
        
        <div style="border-bottom: 1px dashed #000; margin-bottom: 10px;"></div>
        
        <div style="display: flex; justify-content: space-between;">
          <span>Ventes HT/TTC:</span>
          <span>${zData.totalSalesRevenue.toFixed(2)} €</span>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <span>Nb Tickets:</span>
          <span>${zData.totalSalesCount}</span>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <span>Panier Moyen:</span>
          <span>${zData.totalSalesCount > 0 ? (zData.totalSalesRevenue / zData.totalSalesCount).toFixed(2) : "0.00"} €</span>
        </div>

        <div style="border-bottom: 1px dashed #000; margin: 10px 0;"></div>
        <div style="border-bottom: 1px dashed #000; margin: 10px 0;"></div>
        <h4 style="margin: 0 0 5px 0;">Modes de Consommation</h4>
        <div style="display: flex; justify-content: space-between;">
          <span>En Magasin:</span>
          <span>${zData.orderModeBreakdown.magasin.toFixed(2)} €</span>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <span>À Emporter:</span>
          <span>${zData.orderModeBreakdown.emporter.toFixed(2)} €</span>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <span>Livraison:</span>
          <span>${zData.orderModeBreakdown.livrer.toFixed(2)} €</span>
        </div>

        <div style="border-bottom: 1px dashed #000; margin: 10px 0;"></div>
        <h4 style="margin: 0 0 5px 0;">Règlements</h4>
        <div style="display: flex; justify-content: space-between;">
          <span>ESPECES:</span>
          <span>${zData.paymentBreakdown.ESPECES.toFixed(2)} €</span>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <span>CB:</span>
          <span>${zData.paymentBreakdown.CB.toFixed(2)} €</span>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <span>CHEQUE:</span>
          <span>${zData.paymentBreakdown.CHEQUE.toFixed(2)} €</span>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <span>AUTRE:</span>
          <span>${zData.paymentBreakdown.AUTRE.toFixed(2)} €</span>
        </div>

        <div style="border-bottom: 1px dashed #000; margin: 10px 0;"></div>
        <h4 style="margin: 0 0 5px 0;">Caisse</h4>
        <div style="display: flex; justify-content: space-between;">
          <span>Fond de caisse (ouv):</span>
          <span>${zData.openingFloat.toFixed(2)} €</span>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <span>Apports (+):</span>
          <span>${(zData.cashMovementsIn - zData.openingFloat).toFixed(2)} €</span>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <span>Retraits (-):</span>
          <span>${zData.cashMovementsOut.toFixed(2)} €</span>
        </div>
        <div style="display: flex; justify-content: space-between; font-weight: bold; margin-top: 5px;">
          <span>TOTAL ATTENDU:</span>
          <span>${zData.expectedCash.toFixed(2)} €</span>
        </div>
        
        <div style="border-bottom: 1px dashed #000; margin: 10px 0;"></div>
        <h4 style="margin: 0 0 5px 0;">Déclaration Espèces</h4>
        <div style="display: flex; justify-content: space-between;">
          <span>Attendu:</span>
          <span>${zData.expectedCash.toFixed(2)} €</span>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <span>Déclaré:</span>
          <span>${finalCash.toFixed(2)} €</span>
        </div>
        <div style="display: flex; justify-content: space-between; font-weight: bold;">
          <span>Ecart:</span>
          <span style="color: ${diff < 0 ? "#ef4444" : "#10b981"}">${diff > 0 ? "+" : ""}${diff.toFixed(2)} €</span>
        </div>

        <div style="border-bottom: 1px dashed #000; margin: 10px 0;"></div>
        <div style="display: flex; justify-content: space-between;">
          <span>Retours / Avoirs:</span>
          <span>${zData.totalReturnsCount} (-${zData.totalReturnsRevenue.toFixed(2)} €)</span>
        </div>

        <div style="margin-top: 40px; text-align: center;">
          _________________________<br/>
          Signature Caissier
        </div>

        <div style="text-align: center; margin-top: 30px; font-size: 12px;">
          -- FIN DU RAPPORT Z --<br/>
          (Réinitialisation effectuée)
        </div>
      </div>
    `;
    printHtml(html);
  };

  const handleConfirmZ = async () => {
    setIsArchiving(true);
    const cashierId = user?.id || "unknown";
    const cashierName = user?.user_metadata?.full_name || user?.email || "Caissier";
    const finalCash = parseFloat(actualCash) || 0;
    
    try {
      const zReport = await archiveZReport(data, finalCash, cashierId, cashierName);
      
      const diff = finalCash - data.expectedCash;
      handlePrintZ(data, finalCash, diff);
      
      onConfirm(zReport);
    } catch(err) {
      console.error(err);
    } finally {
      setIsArchiving(false);
    }
  };

  const diff = (parseFloat(actualCash) || 0) - (data?.expectedCash || 0);

  return (
    <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.75)", zIndex: 1060 }}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content shadow-lg border-0" style={{ backgroundColor: "#111827", color: "white", borderRadius: "12px" }}>
          
          <div className="modal-header border-bottom-0 pt-4 pb-3" style={{ backgroundColor: "#1f2937", borderRadius: "12px 12px 0 0" }}>
            <h4 className="modal-title fw-bold text-danger">
              <i className="bi bi-exclamation-triangle-fill me-2"></i> CLÔTURE DE CAISSE (Z)
            </h4>
            <button type="button" className="btn-close btn-close-white" onClick={onClose} disabled={isArchiving}></button>
          </div>
          
          <div className="modal-body p-4">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-light" role="status"></div>
                <div className="mt-2 text-muted">Génération du rapport...</div>
              </div>
            ) : step === 1 ? (
              // STEP 1: PREVIEW
              <>
                <div className="alert alert-warning border-0" style={{ backgroundColor: "rgba(245, 158, 11, 0.1)", color: "#fcd34d" }}>
                  <strong>Attention:</strong> La clôture Z archive la session en cours et réinitialise les compteurs de caisse. Cette action est irréversible.
                </div>
                
                <div className="row g-4 mt-1">
                  <div className="col-md-6">
                    <div className="card h-100 bg-dark border-secondary text-white">
                      <div className="card-header border-secondary">Résumé des Ventes</div>
                      <div className="card-body">
                        <h2 className="text-success fw-bold">{data.totalSalesRevenue.toFixed(2)} €</h2>
                        <p className="text-muted">{data.totalSalesCount} transactions</p>
                        <div className="d-flex justify-content-between small border-top border-secondary pt-2 mt-2">
                          <span>En Magasin:</span>
                          <strong>{data.orderModeBreakdown.magasin.toFixed(2)} €</strong>
                        </div>
                        <div className="d-flex justify-content-between small pt-1">
                          <span>À Emporter:</span>
                          <strong>{data.orderModeBreakdown.emporter.toFixed(2)} €</strong>
                        </div>
                        <div className="d-flex justify-content-between small border-top border-secondary pt-2 mt-2">
                          <span>Espèces:</span>
                          <strong>{data.paymentBreakdown.ESPECES.toFixed(2)} €</strong>
                        </div>
                        <div className="d-flex justify-content-between small pt-1">
                          <span>CB:</span>
                          <strong>{data.paymentBreakdown.CB.toFixed(2)} €</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card h-100 bg-dark border-secondary text-white">
                      <div className="card-header border-secondary">Caisse & Mouvements</div>
                      <div className="card-body">
                        <div className="d-flex justify-content-between small">
                          <span>Fond de caisse initial:</span>
                          <strong>{data.openingFloat.toFixed(2)} €</strong>
                        </div>
                        <div className="d-flex justify-content-between small pt-1 text-success">
                          <span>Apports / Divers (+):</span>
                          <strong>{(data.cashMovementsIn - data.openingFloat).toFixed(2)} €</strong>
                        </div>
                        <div className="d-flex justify-content-between small pt-1 text-danger">
                          <span>Retraits (-):</span>
                          <strong>-{data.cashMovementsOut.toFixed(2)} €</strong>
                        </div>
                        
                        <h4 className="text-info fw-bold border-top border-secondary pt-3 mt-3 d-flex justify-content-between">
                          <span>ESPECES ATTENDU:</span>
                          <span>{data.expectedCash.toFixed(2)} €</span>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="d-flex gap-3 mt-5">
                  <button type="button" className="btn btn-secondary btn-lg fw-bold px-4" onClick={onClose}>ANNULER</button>
                  <button type="button" className="btn btn-danger btn-lg fw-bold flex-grow-1" onClick={() => setStep(2)}>
                    ÉTAPE SUIVANTE: DÉCLARATION ESPÈCES <i className="bi bi-arrow-right ms-2"></i>
                  </button>
                </div>
              </>
            ) : (
              // STEP 2: DECLARE CASH
              <>
                <div className="text-center mb-4">
                  <h5 className="text-light opacity-75">Combien avez-vous compté dans le tiroir caisse ?</h5>
                </div>
                
                <div className="mx-auto" style={{ maxWidth: "400px" }}>
                  <div className="mb-4">
                    <label className="form-label text-info fw-bold">ESPÈCES ATTENDU</label>
                    <div className="fs-3 fw-bold text-info border-bottom border-secondary pb-2 mb-4">{data.expectedCash.toFixed(2)} €</div>
                    
                    <label className="form-label text-white fw-bold">ESPÈCES RÉEL (COMPTÉ)</label>
                    <input 
                      type="number" 
                      step="0.01" 
                      min="0"
                      className="form-control form-control-lg bg-dark text-white text-center fw-bold fs-2 border-0" 
                      placeholder="0.00"
                      value={actualCash}
                      onChange={(e) => setActualCash(e.target.value)}
                      autoFocus
                    />
                  </div>
                  
                  {actualCash !== "" && (
                    <div className={"alert " + (diff === 0 ? "alert-success" : diff < 0 ? "alert-danger" : "alert-warning") + " border-0 fw-bold d-flex justify-content-between"}>
                      <span>{diff === 0 ? "Caisse juste" : diff < 0 ? "Manquant (Déficit)" : "Surplus"} :</span>
                      <span>{diff > 0 ? "+" : ""}{diff.toFixed(2)} €</span>
                    </div>
                  )}
                </div>

                <div className="d-flex gap-3 mt-5">
                  <button type="button" className="btn btn-secondary btn-lg fw-bold px-4" onClick={() => setStep(1)} disabled={isArchiving}>RETOUR</button>
                  <button 
                    type="button" 
                    className="btn btn-danger btn-lg fw-bold flex-grow-1" 
                    disabled={actualCash === "" || isArchiving}
                    onClick={handleConfirmZ}
                  >
                    {isArchiving ? (
                      <><span className="spinner-border spinner-border-sm me-2"></span> CLÔTURE EN COURS...</>
                    ) : (
                      <><i className="bi bi-check2-circle me-2"></i> VALIDER LA CLÔTURE Z ET IMPRIMER</>
                    )}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ZClosureModal;


